import { ArrowUpRight, Phone } from 'lucide-react'
import { serviceAreas, site } from '../content/site'
import { BrandMark } from './BrandMark'

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="shell site-footer__cta">
        <div>
          <p className="eyebrow eyebrow--light">Have a project in mind?</p>
          <h2>Let’s make the room impossible to forget.</h2>
        </div>
        <div className="site-footer__cta-actions">
          <a className="button button--accent" href="/contact/">
            Tell us about it <ArrowUpRight aria-hidden="true" />
          </a>
          <a className="text-link text-link--light" href={site.phoneHref}>
            <Phone aria-hidden="true" /> {site.phoneDisplay}
          </a>
        </div>
      </div>
      <div className="shell site-footer__grid">
        <div className="site-footer__about">
          <a href="/"><BrandMark /></a>
          <p>Custom aquarium design, installation, maintenance, and emergency help across Southern California.</p>
          <img
            src="/images/optimized/as-seen-on-tanked-transparent.png"
            alt="As seen on Animal Planet's hit show Tanked"
            width="906"
            height="202"
            loading="lazy"
          />
        </div>
        <div>
          <h3>Explore</h3>
          <a href="/services/">Services</a>
          <a href="/insights/">Insights</a>
          <a href="/contact/">Contact</a>
        </div>
        <div>
          <h3>Core service area</h3>
          <p>{serviceAreas.slice(0, 8).join(' · ')}</p>
        </div>
      </div>
      <div className="shell site-footer__legal">
        <span>© {new Date().getFullYear()} Aquatic Contractors</span>
        <span>Santa Barbara to San Diego</span>
      </div>
    </footer>
  )
}
